import React, { useEffect }  from 'react';

import {  Link, useHistory } from "react-router-dom";
import moment from "moment";

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import IconButton from '@material-ui/core/IconButton'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import MaterialTable from 'material-table'

//service
import DashboardService from "../../services/DashboardService";
import AutocompleteCompany from "../../component/Autocomplete/AutocompleteCompany";
import AutocompleteUser from  '../../component/Autocomplete/AutocompleteUser';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";

import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import Button from '@material-ui/core/Button'
import UserService from "../../services/UserService";
import CompanyService from "../../services/CompanyService";
import ListSimple from '../../component/DragAndDrop/ListSimple'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop:20,
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        display: 'flex'
    }
}));

export default (props) => {

    const classes = useStyles()
    const history = useHistory()
    const [data, setData] = React.useState([])
    const [company, setCompany] = React.useState({"id":"","label":"","socialName":"","identifier":""});
    const [companies, setCompanies] = React.useState([]);
    const [user, setUser] = React.useState({"id": "", "label": ""});
    const [users, setUsers] = React.useState([{"id": "", "label": ""}]);

    const loadListDahboards = () => {

        let params = {
            "company": company ? company.id: null,
            "user": user ? user.id : null
        }

        const response = DashboardService.searchAll(params)
        response
            .then( resp => {
                setData(resp.data.filter(item=>!item.isDefault))
            })
            .catch(error => console.error(error))
    }

    const handleButtonClick = (row) => {
        history.push(`/dashboard/add/${row.id}`);
    }

    const handleAddNew = (row) => {
        history.push(`/dashboard/add`);
    }

    const handlerUserslectItem  = (option, param) => {
        setUser(param);
    }

    const handleCompanySelectItem = (option, param) => {
        setCompany(param);
        searchUsersByCompany(param);

    }

    const handleCompany = (event) => {
        searchCompanyByTerm(event.target.value.trim())
    }

    const handleSearchCompanyDefault = () => {
        searchCompanyByTerm('ads')
    }

    const searchCompanyByTerm = (term) => {

        if(!term || term.length < 2) return

        const companiesResponse = CompanyService.companies(term)
        companiesResponse
            .then(resp => {
                setCompanies(resp.data)
            })
            .catch(err => {
                console.error(err)
            })
    }

    const searchUsersByCompany = (param) => {
        if(!param) return

        const userResponse = UserService.user([param.id])
        userResponse
            .then( resp => {
                setUsers(resp.data)
            })
            .catch(err => {
                console.error(err)
            })
    }

    const handleDelete = (row) => {

        if (window.confirm(`Tem certeza que deseja excluir:\r ${row.name}?`)) {
            const response = DashboardService.delete(row.id);
            response
                .then(resp => {
                    const newDataList = data.filter((item) => item.id !== row.id);
                    setData(newDataList);
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }

    const handleCopy = (row) => {
        if (window.confirm(`Tem certeza que deseja copiar:\r ${row.name}?`)) {
            const response = DashboardService.copy(row.id);
            response
                .then(resp => {
                    history.push(`/dashboard/add/${resp.data.id}`);
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }



    useEffect(() => {
        loadListDahboards();
    }, [user, company])

    return (
        <Container className={classes.root} >

            <Grid item xs={12} >
                <Breadcrumbs aria-label="breadcrumb">
                    <Link color="inherit" to="/"  >
                        <Home/>
                    </Link>
                    <Typography color="textPrimary">Lista de Dashboards</Typography>
                </Breadcrumbs>
            </Grid>



            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper} >
                        <IconButton color="primary" onClick={handleAddNew} ><AddCircleIcon /></IconButton>

                        <Grid item xs={6}  >
                            <Autocomplete
                                value={company}
                                onChange={handleCompanySelectItem}
                                onKeyUp={handleCompany}
                                filterSelectedOptions
                                options={companies}
                                getOptionLabel={(option) => {
                                     return option.id +" - " + option.label;
                                }}
                                getOptionSelected={(option, value) => option.label === value.label}
                                renderOption={(option) => {
                                    return `${option.id} | ${option.label} | ${option.identifier ? `cnpj ${option.identifier}`:''}`
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            color="primary"
                                            label={option.id + ' ' + option.label}
                                            {...getTagProps({ index })}
                                        />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        onClick={handleSearchCompanyDefault}
                                        variant="standard"
                                        label="Empresas"
                                        placeholder="Selecione"
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}  >
                            <Autocomplete
                                value={user}
                                options={users}
                                getOptionLabel={(option) => option.username || "" }
                                getOptionSelected={(option, value) => option.username === value.username}
                                onChange={handlerUserslectItem}
                                renderOption={(option) => {
                                    return `${option.id} | ${option.label} | ${option.username}`
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip color="primary" label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        label="Usuários"
                                        {...params}
                                        variant="standard"
                                    />
                                )}
                            />
                        </Grid>

                    </Paper>
                </Grid>
                <Grid item xs={12}>

                    <MaterialTable
                        title="Conectores"
                        allowfullscreen
                        data={data}
                        options={{
                            search: true
                        }}
                        columns={[
                            {
                                title: 'Ordem',
                                field: 'order'
                            },
                            {
                                title: 'Ativo',
                                field: 'enable'
                            },
                            {
                                title: 'Descrição',
                                field: 'name',
                            },
                            {
                                title: 'Cadastro',
                                field: 'register',
                                render: row => moment(row.register).format('DD/MM/YYYY'),
                            },
                            {
                                title: 'Alteração',
                                field: 'lastUpdate',
                                render: row => moment(row.lastUpdate).format('DD/MM/YYYY'),
                            },
                            {
                                title: 'Usuários',
                                field: 'users',
                                render: row =>  row.users.join(" - ")
                            },
                            {
                                title: 'Empresas',
                                field: 'companies',
                                render: row =>  row.companies.join(" - ")
                            }
                        ]}
                        actions={[
                            {
                                icon: 'edit',
                                tooltip: 'Editar Dashboard',
                                onClick: (event, row) => handleButtonClick(row),
                            },
                            {
                                icon: 'delete',
                                tooltip: 'Excluir Dashboard',
                                onClick: (event, row) => handleDelete(row)
                            },
                            {
                                icon: 'content_copy',
                                tooltip: 'Copiar dashboard',
                                onClick: (event, row) => handleCopy(row)
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        </Container>
    )

}